<template>
	<div class="content-main">
		<!-- 项目类别编辑弹窗 -->
		<Sprjtype @close='isxz=false' v-if="isxz" @editg='editclass'></Sprjtype>
		<!-- 资料上传弹窗 -->
		<!-- 	<Supziliao v-if="iszl" :ziliaoprj="ziliaoprj" :projectName="project.projectName" @close="iszl=false"
			@hcziliao='shondanziliao'></Supziliao> -->
		<Supziliao v-if="iszl" :ziliaoprj="ziliaoprj" :projectName="project.projectName" @close="iszl=false"
			@hcziliao='shondanziliao'>
		</Supziliao>
		<!-- 左侧项目列表 -->
		<div class="content-left">
			<div class="left-tou">{{ Smenuname }}</div>
			<div class="left-center">
				<div class="left-list" v-for="(s, index) in Sshowlist" :key="index"
					:class="{ 'mingxi-content1': s.projectId == zyindex }" @click="zyindex=s.projectId; Ezlqd(s)"
					:title="s.projectName">
					{{prjectsl(s.projectName,15)}}
				</div>
			</div>
		</div>

		<!-- 右侧项目详情 -->
		<div class="content-center">
			<div class="zlqd-tou">
				<div class="zlqd-title" style="cursor: pointer" :title="project.projectName || '未选择'">
					项目名称：{{project.projectName?prjectsl(project.projectName,20):'未选择'}}</div>
				<div class="zlqd-jiage">
					<el-button size="medium" type="primary" @click="editproject" v-if="project.projectName"
						style="width: 70px;">保存</el-button>
				</div>
				<div class="zlqd-jiage1">
					<span v-if="project.engineerUserName" class="gcscp">
						<div class="gcscat">工程师：{{project.engineerUserName}}
							<img src="../../assets/对话.png" style="height: 20px;width: 20px;"
								v-if="project.engineerUserName" @click="ischat()" />
							<el-tooltip :content="project.engineerPhone" placement="top"
								v-if="project.engineerUserName">
								<img src="../../assets/电话.png" style="height: 20px;width: 20px;" />
							</el-tooltip>

						</div>
						<el-tooltip class="box-item" effect="dark" content="差评" placement="top"
							v-if="!project.evaluateEngineerUserIds?.includes(project.engineerUserId)">
							<img src="../../assets/差评.png" class="cpimg" @click="Schap()" />
						</el-tooltip>
						<el-tooltip class="box-item" effect="dark" content="撤消差评" placement="top" v-else>
							<img src="../../assets/差评1.png" class="cpimg" @click="Sdelchap()" />
						</el-tooltip>
					</span>
				</div>
			</div>
			<div class=" zlqd-list">
				<!-- 项目基础信息表单 -->
				<div class="zlqd-content">
					<div class="name-list">
						<div class="name">
							<div class="title">委托人：</div>
							<div class="xm-content" :class="{'xm-content1':ists}">{{wtrts()}}</div>
						</div>
						<div class="name">
							<div class="title">项目类别：</div>
							<div class="xm-content" @click="changeclass">{{Sclass()}} </div>
						</div>
						<div class="name">
							<div class="title">项目价格：</div>
							<div class="xm-content">{{xmjg()}}</div>
							<!-- 支付按钮 -->
							<el-button v-if="project.payFlag=='0' && JSON.stringify(bz)!=='{}'" type="danger"
								class="fufei" size="small" @click="handlePayment(project)">
								支付编制费
							</el-button>
							<el-button v-if="project.payFlag=='0' && JSON.stringify(bz)!=='{}'" type="warning"
								class="free-code-btn" size="small" @click="openFreeCodeDialog">
								免费码
							</el-button>
							<!-- 已支付状态 -->
							<span v-else-if="project.payFlag=='1'" class="paid-text">已支付</span>
						</div>
						<div class="name">
							<div class="title">项目名称：</div>
							<div class="xm-content" v-if="JSON.stringify(this.bz) !== '{}'">
								<input type="text" class="input-control" v-model="prjname"
									:placeholder="prjname?prjname:'请填写项目名称'">
								<span class="clear-icon" v-if="prjname" @click="prjname = ''">×</span>
							</div>
						</div>
						<div class="name">
							<div class="title">编制期限：</div>
							<div class="xm-content" v-if="JSON.stringify(this.bz) !== '{}'">
								<div v-if="project.payFlag=='1'">
									{{bzqx=='0'?'加急'+Math.ceil(bz.prepareCycle/2)+'天':bz.prepareCycle+'天'}}
								</div>
								<el-radio-group v-model="bzqx" v-else>
									<el-radio :label="1" class="bzqxs">正常{{bz.prepareCycle}}天</el-radio>
									<el-radio :label="0" class="bzqxs">加急{{Math.ceil(bz.prepareCycle/2)}}天</el-radio>
								</el-radio-group>
								<div class="Sqixian"><span class="Sastar">*</span><span
										class="sl">资料齐全且付款后启动编制倒计时</span></div>
							</div>
						</div>
						<div class="name">
							<div class="title">建设性质：</div>
							<div class="xm-content" v-if="JSON.stringify(this.bz) !== '{}'">
								<el-radio-group v-model="jsxz">
									<el-radio :label="'新建'">新建</el-radio>
									<el-radio :label="'改造'">改造</el-radio>
									<el-radio :label="'扩建'">扩建</el-radio>
								</el-radio-group>
							</div>
						</div>
						<div class="name">
							<div class="title">建设周期：</div>
							<div class="xm-content" v-if="JSON.stringify(this.bz) !== '{}'">
								<Ssqbz :initStartDate="stardate" :initEndDate="enddate"
									@dateChange="handleDateRangeChange"></Ssqbz>
							</div>
						</div>
						<div class="name">
							<div class="title">其他说明：</div>
						</div>
						<div class="name">
							<div class="xm-content">
								<el-input type="textarea" v-model="content" :rows="5" :maxlength="1500"
									placeholder="请输入说明（最多1500字）" show-word-limit style="width: 34vw;padding-left: 5px;"
									resize="none"></el-input>
								<span class="content-icon" v-if="content" @click="content = ''">×</span>
							</div>
						</div>
					</div>
				</div>

				<!-- 资料清单 -->
				<div class="zlqd-content">
					<div class="zlqd-Stile">需提供资料清单
						<div class="tools" v-if="JSON.stringify(project)!=='{}'">
							<el-button size="mini" type="text" @click="downloadWord">
								<i class="el-icon-download"></i>
								下载清单
							</el-button>
							<el-button size="mini" type="text" @click="upfile(project)">
								<i class="el-icon-upload"></i>
								上传资料
							</el-button>
						</div>
					</div>
					<div class="zlqd-li">
						<div class="zlqd-contitle" v-for="(item, ind) in zllist" :key="ind">
							{{ ind + 1 }}.{{ item.informationTypeName }}

						</div>
					</div>


				</div>
			</div>
			<div class="content-center-z" v-if="isbz"></div>
		</div>
		<div class="pay" v-if="showPaymentDialog">
			<PaymentDialog :project="project" :amount="getPaymentAmount()" @paymentSuccess="handlePaymentSuccess"
				@paymentCancel="handlePaymentCancel" @close="showPaymentDialog=false" />
		</div>
		<el-dialog title="免费码支付" :visible.sync="freeCodeDialogVisible" width="420px" :close-on-click-modal="false"
			:append-to-body="true" :modal-append-to-body="true" @close="resetFreeCodeDialog">
			<el-input v-model.trim="freeCode" clearable maxlength="32" placeholder="请输入免费码"></el-input>
			<div class="free-code-dialog-tip">输入免费码后直接支付项目费用，不调用微信支付。</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="freeCodeDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="freeCodePaying" @click="submitFreeCodePay">确认支付</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	// 仅保留核心接口（项目编辑、资料查询/上传、类别查询）
	import {
		zyemg,
		subclass,
		editPRJ,
		addzl,
		editxmzl,
		chap,
		delchap,
		ALLprj,
		upzl,
		payProjectByCode
	} from "../../utils/request.js";
	// 保留所有使用的子组件
	import Ssqbz from "./Ssqbz.vue";
	import Supziliao from "./Supziliao.vue";
	import Sprjtype from "./Sprjtype.vue";
	import PaymentDialog from "./PaymentDialog.vue";
	// 保留缓存工具（获取项目类别、用户名）
	import {
		Getitem
	} from "../../utils/item.js";
	import {
		Document,
		Packer,
		Paragraph,
		TextRun,
		HeadingLevel
	} from 'docx'

	export default {
		props: {
			Smenuname: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				// -------------------------- 核心业务变量 --------------------------
				zyindex: -1, // 当前选中sendid（左侧列表高亮用）
				prjtype: Getitem('setmenu'), // 所有项目类别（缓存获取）
				prjname: '', // 当前项目名称（表单绑定）
				bz: {}, // 项目类别配置（含价格、周期、系数）
				isxz: false, // 项目类别弹窗显示状态
				project: {}, // 当前选中项目完整信息
				files: [], // 当前项目的原始资料列表
				Sprojectid: '', // 当前sendid（资料操作用）
				zllist: [], // 当前项目的资料清单（右侧展示用）
				isbz: false, // 备用弹窗控制（保留原逻辑）
				ists: false, // 委托人登录警告样式控制
				bzqx: 1, // 编制期限（1正常/0加急）
				jsxz: '新建', // 建设性质（默认新建）
				content: '', // 其他说明（文本域绑定）
				name: Getitem('name'), // 登录用户名（缓存获取）
				stardate: '', // 建设开始日期（日期选择器绑定）
				enddate: '', // 建设结束日期（日期选择器绑定）
				iszl: false, // 资料上传弹窗显示状态
				ziliaoprj: [], // 传递给资料弹窗的当前资料项
				discipline: '', // 项目类别名称（格式化显示用，如“可行性研究报告”）
				showPaymentDialog: false,
				freeCodeDialogVisible: false,
				freeCode: '',
				freeCodePaying: false,
				Sshowlist: []
			};
		},
		components: {
			Ssqbz,
			Supziliao,
			Sprjtype,
			PaymentDialog
		},
		methods: {
			showphone(e) {
				this.$toast.success(e);
			},
			upfile(project) {
				this.ziliaoprj = JSON.parse(project.informationUrls) || []
				this.iszl = true

			},
			prjectsl(e, num) {
				if (e.length > num) {
					const res = e.slice(0, num);
					return `${res}...`
				} else {
					return e
				}
			},

			downloadWord() {
				if (this.zllist.length === 0) {
					this.$toast.error('没有资料清单可下载')
					return
				}

				try {
					// 创建HTML内容
					let htmlContent = `
			            <!DOCTYPE html>
			            <html>
			            <head>
			                <meta charset="UTF-8">
			                <title>资料清单</title>
			                <style>
			                    body { 
			                        font-family: "Microsoft YaHei", "SimSun", sans-serif; 
			                        margin: 20px; 
			                        line-height: 1.6;
			                    }
			                    h1 { 
			                        color: #333; 
			                        text-align: center; 
			                        margin-bottom: 20px;
			                        border-bottom: 2px solid #409eff;
			                        padding-bottom: 10px;
			                    }
			                    .info-section {
			                        margin-bottom: 20px;
			                        padding: 15px;
			                        background-color: #f5f7fa;
			                        border-radius: 5px;
			                    }
			                    .info-item {
			                        margin: 8px 0;
			                    }
			                    .info-label {
			                        font-weight: bold;
			                        color: #333;
			                        min-width: 80px;
			                        display: inline-block;
			                    }
			                    .list-title {
			                        font-size: 18px;
			                        font-weight: bold;
			                        color: #409eff;
			                        margin: 20px 0 10px 0;
			                    }
			                    .list-item {
			                        margin: 10px 0;
			                        padding-left: 20px;
			                        position: relative;
			                    }
			                    .list-item:before {
			                        content: "•";
			                        color: #409eff;
			                        font-size: 20px;
			                        position: absolute;
			                        left: 0;
			                        top: -2px;
			                    }
			                    .item-index {
			                        font-weight: bold;
			                        color: #333;
			                        margin-right: 8px;
			                    }
			                    .footer {
			                        margin-top: 30px;
			                        text-align: right;
			                        color: #666;
			                        font-size: 12px;
			                        border-top: 1px dashed #ddd;
			                        padding-top: 10px;
			                    }
			                </style>
			            </head>
			            <body>
			                <h1>项目资料清单</h1>
			                
			                <div class="info-section">
			                    
			                    <div class="info-item">
			                        <span class="info-label">项目类别：</span>
			                        ${this.Sclass() || '未选择项目类别'}
			                    </div>
								<div class="info-item">
								    <span class="info-label">编制期限：</span>
								
								   正常 ${this.bz.prepareCycle}天，加急${Math.ceil(this.bz.prepareCycle/2)}天
								</div>
								<div class="info-item">
								    <span class="info-label">费用：</span>
								
								   正常： ${this.bz.preparePrices}元，加急：${this.bz.preparePrices * this.bz.factor}元
								</div>
			                    
			                </div>
			                
			                <div class="list-title">需提资料清单（共${this.zllist.length}项）</div>
			        `;

					// 添加清单列表
					this.zllist.forEach((item, index) => {
						htmlContent += `
			                <div class="list-item">
			                    <span class="item-index">${index + 1}.</span>
			                    <strong>${item.informationTypeName}</strong>
			                </div>
			            `;
					});

					htmlContent += `
			                <div class="footer">
			                    系统自动生成 · ${new Date().getFullYear()}年${new Date().getMonth()+1}月${new Date().getDate()}日
			                </div>
			            </body>
			            </html>
			        `;

					// 创建Blob并下载
					const blob = new Blob([htmlContent], {
						type: 'application/msword'
					});

					// 生成文件名
					const projectName = this.Sclass();
					const fileName = `资料清单_${projectName}.doc`;

					// 使用原生的下载方法
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(link.href);

					this.$toast.success('资料清单下载成功');
				} catch (error) {
					// console.error('生成文档失败:', error);
					this.$toast.error('下载失败，请重试');
				}
			},
			handlePayment() {
				this.showPaymentDialog = true;
				// console.log('用于支付的项目：', this.project);
			},
			openFreeCodeDialog() {
				if (!this.project.engineerUserId) {
					this.showPaymentDialog = true;
					return;
				}
				this.freeCodeDialogVisible = true;
			},
			resetFreeCodeDialog() {
				this.freeCode = '';
				this.freeCodePaying = false;
			},
			async submitFreeCodePay() {
				if (!this.project || !this.project.projectId) {
					this.$message.error('项目信息不完整，无法支付');
					return;
				}
				if (!this.project.engineerUserId) {
					this.freeCodeDialogVisible = false;
					this.showPaymentDialog = true;
					return;
				}
				if (!this.freeCode) {
					this.$message.warning('请输入免费码');
					return;
				}

				this.freeCodePaying = true;
				try {
					const res = await payProjectByCode({
						code: this.freeCode,
						projectId: this.project.projectId
					});

					if (res && res.code === 200) {
						this.$message.success('支付成功');
						this.freeCodeDialogVisible = false;
						this.handlePaymentSuccess(this.project.projectId);
					} else {
						this.$message.error((res && res.msg) || '免费码支付失败');
					}
				} catch (error) {
					this.$message.error((error && error.message) || '免费码支付失败，请重试');
				} finally {
					this.freeCodePaying = false;
				}
			},

			// 获取支付金额
			getPaymentAmount() {
				if (JSON.stringify(this.bz) === '{}') return '0';
				return this.bzqx != 0 ?
					this.bz.preparePrices :
					this.bz.preparePrices * this.bz.factor;
			},

			// 支付成功回调
			handlePaymentSuccess(projectId) {
				// 更新项目支付状态
				this.project.payFlag = '1';
				// 可以在这里调用接口更新项目支付状态到后端
				this.allprj();
			},

			// 支付取消回调
			handlePaymentCancel() {
				// 支付取消处理
				// console.log("支付已取消");
			},
			ischat() {
				let data = {
					toid: this.project.engineerUserId,
					toname: this.project.engineerUserName,
					myname: this.name,
					myid: Getitem('userid'),
					toclass: 'eng'
				}
				this.$store.commit('setgochat', data)
			},
			async Sdelchap() {
				let data = {
					engineerUserId: this.project.engineerUserId,
					projectId: this.project.projectId
				}
				let s = await delchap(data)
				if (s.code === 200) {
					this.$toast.success('差评撤消完成')
					const index = this.project.evaluateEngineerUserIds.indexOf(this.project.engineerUserId);
					if (index !== -1) {
						this.project.evaluateEngineerUserIds.splice(index, 1); // 从索引index开始，删除1个元素
					}
					this.allprj()
				} else {
					this.$toast.error('差评撤消失败')
				}

			},
			async Schap() {
				let data = {
					engineerUserId: this.project.engineerUserId,
					projectId: this.project.projectId
				}
				let s = await chap(data)
				if (s.code === 200) {
					this.$toast.success('已给予差评')
					let s = this.project.evaluateEngineerUserIds || []
					s.push(this.project.engineerUserId)
					this.project.evaluateEngineerUserIds = s
					this.allprj()

				} else {
					this.$toast.error('差评未成功')
				}

			},

			/**
			 * 加载选中项目的资料列表，触发资料清单查询
			 * @param {Object} file - 选中的项目对象
			 */
			async Ezlqd(file) {
				this.files = await file.information;
				this.zllist = [];
				this.Szlcx(file);
				// console.log('选择项目：', file);
			},


			async editproject() {
				if (!this.prjname) {
					this.$toast.error('没有填写项目名称！');
					return;
				}
				if (!this.stardate || !this.enddate) {
					this.$toast.error('没有填写项目建设周期！');
					return;
				}
				const start = new Date(this.stardate).getTime();
				const end = new Date(this.enddate).getTime();
				if (start > end) {
					this.$toast.error('建设周期开始时间不能在结束时间之后！');
					return;
				}
				const data = {
					projectId: this.project.projectId,
					projectTypeId: this.project.projectTypeId,
					projectAmount: this.xmjg(),
					projectName: this.prjname,
					industryTypeId: this.project.industryTypeId,
					cycle: this.bzqx == 0 ? 0 : this.bz.prepareCycle,
					nature: this.jsxz,
					startDate: this.stardate,
					finishDate: this.enddate,
					description: this.content
				};
				const s = await editPRJ(data);
				if (s.code === 200) {
					this.$toast.success('修改成功');
					this.allprj()
				} else {
					this.$toast.error(s.msg);
				}
			},

			/**
			 * 接收项目类别弹窗的编辑结果，更新当前项目配置
			 * @param {Object} e - 编辑后的类别配置（含行业ID、价格、周期）
			 */
			async editclass(e) {
				this.project.industryTypeId = e.industryTypeId;
				this.project.projectTypeId = e.projectTypeId;
				// 计算项目价格（加急按系数）
				this.project.projectAmount = this.bzqx == 0 ? e.preparePrices * e.factor : e.preparePrices;
				// 计算编制周期（加急为0）
				this.project.cycle = this.bzqx == 0 ? 0 : e.prepareCycle;
				// 同步表单其他信息
				this.project.startDate = this.stardate;
				this.project.finishDate = this.enddate;
				this.project.description = this.content;
				this.project.nature = this.jsxz;
				this.project.projectName = this.prjname;
				// 重新查询项目资料清单
				this.Szlcx(this.project);
			},

			/** 显示项目类别编辑弹窗 */
			changeclass() {
				if (this.project.payFlag === '1') {
					this.$toast.error('已完成支付，不能修改');
				} else {
					this.isxz = true;
				}
			},

			async Szlcx(E) {
				this.project = Object.assign({}, E); // 深拷贝避免源数据污染

				this.Sprojectid = E.projectId;
				// 匹配项目类别名称（如“可行性研究报告”）
				this.prjtype.forEach(r => {
					r.list.forEach(n => {
						if (n.projectTypeId == E.projectTypeId) {
							this.discipline = n.projectType;
						}
					});
				});
				// 查询项目子类配置（价格、周期）
				const id = await this.cxgzmc(E);
				// 同步表单绑定值
				this.bzqx = E.cycle != 0 ? 1 : 0;
				this.prjname = E.projectName;

				this.jsxz = E.nature;
				this.stardate = E.startDate;
				this.enddate = E.finishDate;
				this.content = E.description;
				// 查询项目资料清单
				await this.Szllist(id);
			},


			async cxgzmc(r) {
				try {
					const res = await subclass(r.projectTypeId);
					if (res.code === 200 && res.list && res.list.length > 0) {
						// 筛选当前项目所属行业的配置
						const industryConfig = res.list.filter(e => e.industryTypeId == r.industryTypeId);

						if (industryConfig.length > 0) {
							this.bz = industryConfig[0];
							// console.log('项目：', this.bz);
							return this.bz.subclassId;
						} else {
							// 如果没有匹配的行业配置，使用第一个配置作为默认值
							// console.warn('未找到匹配的行业配置，使用默认配置');
							this.bz = res.list[0];
							// console.log('项目：', this.bz);
							return this.bz.subclassId;
						}

					} else {
						// console.error('获取项目子类配置失败:', res.msg);
						this.$toast.error('获取项目配置失败');
						// 返回一个默认值或空字符串，避免后续错误
						return '';
					}
				} catch (error) {
					// console.error('查询项目子类明细异常:', error);
					this.$toast.error('查询项目配置异常');
					return '';
				}
			},



			async Szllist(id) {
				// 如果id为空，直接返回
				if (!id) {
					// console.warn('子类ID为空，无法查询资料清单');
					this.zllist = [];
					return;
				}

				try {
					const zlres = await zyemg(id);
					if (zlres.code === 200 && zlres.list) {
						const syszl = zlres.list;
						const su = [];

						// 使用Promise.all等待所有异步操作完成
						const promises = syszl.map(async (res) => {
							let suhua = {};

							// 在现有文件中查找匹配的资料
							if (this.files && this.files.length > 0) {
								this.files.forEach(item => {
									if (res.informationTypeId == item.informationTypeId) {
										let Snum = 0;
										if (item.content) Snum += 1;
										if (item.Files && item.Files.length > 0) Snum += item.Files
											.length;

										suhua = {
											informationTypeId: res.informationTypeId,
											informationTypeName: res.informationTypeName,
											Files: item.Files || [],
											content: item.content,
											examineFlag: item.examineFlag,
											projectId: item.projectId,
											projectInformationId: item.projectInformationId,
											updateTime: item.updateTime,
											Snum
										};
									}
								});
							}

							// 如果没有找到现有资料，初始化新资料记录
							if (JSON.stringify(suhua) === '{}') {
								suhua = {
									informationTypeId: res.informationTypeId,
									informationTypeName: res.informationTypeName,
									Files: [],
									content: null,
									examineFlag: "0",
									projectId: this.Sprojectid,
									projectInformationId: '',
									updateTime: "",
									Snum: 0
								};

								// 初始化资料记录到数据库
								try {
									const im = await addzl({
										projectId: this.Sprojectid,
										informationTypeId: res.informationTypeId,
										Files: JSON.stringify([]),
										content: ""
									});
									if (im.code !== 200) {
										// console.error('初始化资料记录失败:', im.msg);
									}
								} catch (error) {
									// console.error('初始化资料记录异常:', error);
								}
							}

							return suhua;
						});

						// 等待所有资料处理完成
						const results = await Promise.all(promises);
						this.zllist = results.filter(item => item); // 过滤掉空项
					} else {
						// console.error('查询资料清单失败:', zlres.msg);
						this.$toast.error('查询资料清单失败');
						this.zllist = [];
					}
				} catch (error) {
					// console.error('查询资料清单异常:', error);
					this.$toast.error('查询资料清单异常');
					this.zllist = [];
				}
			},

			async shondanziliao(e) {
				let data = {
					projectId: this.Sprojectid,
					informationUrls: JSON.stringify(e)

				}


				const u = await upzl(data);
				if (u.code == 200) {
					await this.allprj()
					this.project = this.Sshowlist.filter(res => res.projectId == this.project.projectId)[0]
				} else {
					this.$toast.error(u.msg);
				}
			},


			async Supqingdan(item) {
				this.ziliaoprj = await item;
				this.iszl = true;
			},

			xmjg() {
				if (JSON.stringify(this.bz) == '{}') return '';
				return this.bzqx != 0 ?
					`${this.bz.preparePrices}元` :
					`${this.bz.preparePrices * this.bz.factor}元`;
			},

			/**
			 * 接收日期选择器的日期范围，同步到本地变量
			 * @param {Object} range - 日期范围（含startDate/endDate）
			 */
			handleDateRangeChange(range) {
				this.stardate = range.startDate;
				this.enddate = range.endDate;
			},

			/**
			 * 格式化显示项目类别（如“可行性研究报告（工业类）”）
			 * @returns {string} 格式化后的类别名称
			 */
			Sclass() {
				if (JSON.stringify(this.bz) === '{}') return '';
				return `${this.discipline}（${this.bz.industryTypeName}）`;
			},

			/**
			 * 显示委托人信息（未登录时提示警告）
			 * @returns {string} 委托人名称或登录警告
			 */
			wtrts() {
				if (!this.name) {
					this.ists = true;
					return "你没有登录，无法委托，我们也无法为您发送成果！";
				} else {
					this.ists = false;
					return this.name;
				}
			},

			/** 备用方法：控制isbz弹窗（保留原逻辑，未实际调用） */
			sqbz() {
				this.isbz = true;
			},
			async allprj() {
				const res = await ALLprj();
				if (res.code === 200) {
					let pros = res.list;
					// 解析项目中的资料文件（Files字段为JSON字符串，转成数组）
					pros.forEach(r => {
						r.information = r.information || [];
						r.information.forEach(d => {
							d.Files = JSON.parse(d.Files || '[]');
						});
					});
					this.Sshowlist = pros.filter(item => item.finishFlag === '0');
					// console.log(this.prjlist);
				} else {
					this.$toast.error(res.msg || '获取项目列表失败');
				}
			},


		},
		computed: {
			/** 格式化显示项目类别（备用，保留原逻辑） */
			displayText() {
				return this.discipline ? this.discipline : "请选择类型";
			}
		},
		created() {
			this.allprj()
		},


	};
</script>

<style lang="less" scoped>
	/* 完全保留原有样式，无任何修改 */
	.content-main {
		height: 70vh;
		width: 100vw;
		margin-top: 15px;
		/* background-color: white; */
		display: flex;
		justify-content: start;
		align-items: center;

		.content-left {
			width: 15vw;
			height: 90%;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			margin-left: 15px;

			.left-tou {
				width: 85%;
				margin: auto;
				padding: 7px 7px 5px 7px;
				font-size: 17px;
				text-align: center;
				line-height: 35px;
				font-weight: bold;
				border-bottom: 1px solid #dfdfdf;
				margin-bottom: 5px;
			}

			.left-center {
				height: 87%;
				width: 92%;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				align-items: start;
				// justify-content: center;
				line-height: 30px;
				padding-top: 6px;
				padding-left: 10px;
				overflow: auto;
				scrollbar-width: none;
				-ms-overflow-style: none;


				.left-list {
					width: 100%;
					text-align: left;
					font-size: 13px;
					line-height: 30px;
					border-bottom: 1px dashed #dddddd;
					cursor: pointer;
					font-weight: 900;
					position: relative;
					display: inline-block;
				}

				.left-list::after {
					content: attr(data-tooltip);
					position: absolute;
					bottom: 100%;
					left: 50%;
					transform: translateX(-50%);
					background: rgba(0, 0, 0, 0.8);
					color: white;
					padding: 5px 10px;
					border-radius: 4px;
					font-size: 12px;
					white-space: nowrap;
					opacity: 0;
					visibility: hidden;
					transition: opacity 0.3s;
					z-index: 1000;
					pointer-events: none;
				}

				// .left-list:hover::after {
				// 	opacity: 1;
				// 	visibility: visible;
				// }

				// /* 小箭头 */
				// .left-list::before {
				// 	content: '';
				// 	position: absolute;
				// 	bottom: 100%;
				// 	left: 50%;
				// 	transform: translateX(-50%);
				// 	border: 5px solid transparent;
				// 	border-top-color: rgba(0, 0, 0, 0.8);
				// 	opacity: 0;
				// 	visibility: hidden;
				// 	transition: opacity 0.3s;
				// 	z-index: 1000;
				// 	margin-bottom: -5px;
				// }

				// .left-list:hover::before {
				// 	opacity: 1;
				// 	visibility: visible;
				// }

				.left-list:hover {
					color: #409eff !important;
				}
			}
		}

		.content-center {
			width: 80vw;
			height: 63vh;
			background-color: #409eff;
			margin-left: 1.5vw;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			display: flex;
			flex-direction: column;
			align-content: center;
			justify-content: start;
			position: relative;

			.content-center-z {
				width: 80vw;
				height: 63vh;
				background-color: #409eff;
				// margin-left: 1.5vw;
				background-color: #fdfdfd;
				border-radius: 10px;
				box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 50;
			}

			.zlqd-tou {
				width: 100%;
				height: 5.5vh;
				margin: 0 auto;
				display: flex;
				justify-content: start;
				align-items: center;
				font-weight: bold;
				font-size: 17px;
				border-bottom: 1px solid #dfdfdf;
				position: relative;

				.zlqd-title {
					padding-left: 15px;
					padding-top: 5px;
					position: relative;
					display: inline-block;

					.zlqd-title::after {
						content: attr(data-tooltip);
						position: absolute;
						bottom: 100%;
						left: 50%;
						transform: translateX(-50%);
						background: rgba(0, 0, 0, 0.8);
						color: white;
						padding: 5px 10px;
						border-radius: 4px;
						font-size: 12px;
						white-space: nowrap;
						opacity: 0;
						visibility: hidden;
						transition: opacity 0.3s;
						z-index: 1000;
						pointer-events: none;
					}

					.zlqd-title:hover::after {
						opacity: 1;
						visibility: visible;
					}

					/* 小箭头 */
					.zlqd-title::before {
						content: '';
						position: absolute;
						bottom: 100%;
						left: 50%;
						transform: translateX(-50%);
						border: 5px solid transparent;
						border-top-color: rgba(0, 0, 0, 0.8);
						opacity: 0;
						visibility: hidden;
						transition: opacity 0.3s;
						z-index: 1000;
						margin-bottom: -5px;
					}

					.zlqd-title:hover::before {
						opacity: 1;
						visibility: visible;
					}
				}

				.zlqd-jiage {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					// width: 420px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 13px;
					padding-top: 5px;
					padding-right: 30px;

					.jiage {
						width: 140px;
					}
				}

				.zlqd-jiage1 {
					position: absolute;
					top: 50%;
					right: 5px;
					transform: translate(-50%, -50%);
					font-size: 16px !important;
					// width: 420px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 13px;
					padding-top: 5px;
					padding-right: 30px;
				}

			}



			.zlqd-list {
				width: 78vw;
				height: 54vh;
				margin: 0 auto;
				// background-color: #18688d;
				margin-top: 1.5vh;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.zlqd-content {
					width: 37.5vw;
					height: 53vh;
					background-color: rgba(233, 233, 233, 0.5);
					box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
					border-radius: 0 0 10px 10px;
					padding: 8px;
					position: relative;

					.wt-but {
						position: absolute;
						bottom: 10px;
						left: 50%;
						transform: translate(-50%, -50%);
					}

					.zlqd-Stile {
						height: 3vh;
						width: 100%;
						font-size: 16px;
						font-weight: bold;
						text-align: start;
						border-bottom: 1px solid #dfdfdf;
						display: flex;
						position: relative;

						.tools {
							position: absolute;
							top: 50%;
							right: 10px;
							transform: translateY(-50%);
							display: flex;
							align-items: center;
							justify-content: center;
							gap: 15px;
							width: 150px;

							.downlist {
								font-size: 13px;
								display: flex;
								align-items: center;
								gap: 5px;
								cursor: pointer;
								padding: 4px 8px;
								border-radius: 4px;
								transition: all 0.3s;

								&:hover {
									background-color: #f0f0f0;
									color: #409eff;
								}

								.el-icon {
									font-size: 14px;
								}
							}
						}

						.zlqd-shuom {
							font-size: 13px;
							font-weight: 200;
							color: red;

							.Sblack {
								color: #606266;
							}
						}
					}

					.zlqd-li {
						height: 50vh;
						width: 100%;
						overflow: auto;
						scrollbar-width: none;
						-ms-overflow-style: none;


						.zlqd-contitle {
							// height: 3vh;
							display: flex;
							align-items: center;
							// justify-content: center;
							border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
							font-size: 13px;
							padding: 4px 0;

							text-align: left;
							position: relative;
							// padding: 10rpx 0;


							.upshuoming {
								position: absolute;
								top: 50%;
								right: -5px;
								transform: translate(-50%, -50%);
								display: flex;
								align-items: center;
								justify-content: end;

								.uptext {
									font-weight: bold;
									color: #409eff;
									margin -right: 10px;
									border: 1px solid #409eff;
									width: 16px;
									height: 16px;
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-content: center;
									cursor: pointer;
								}


							}


						}
					}

					.name-list {
						margin: auto;
						width: 36vw;
						height: 52vh;
						line-height: 60px;
						display: flex;
						flex-direction: column;
						justify-content: start;
						align-items: start;

						// padding: 10px 15px;
						.name {
							font-size: 15px;
							line-height: 40px;
							padding: 5 10px;
							text-align: left;
							display: flex;
							align-items: center;
							justify-content: start;


							.title {
								width: 80px;
								text-align: right;
							}

							.titlesf {
								width: 80px;
								display: flex;
								align-items: flex-start;
							}

							.xm-content1 {
								padding: 2px 0;
								font-weight: 200 !important;

							}

							.xm-content {
								// font-weight: bold;
								position: relative;
								display: flex;
								align-items: center;
								position: relative;
								cursor: pointer;

								.content-icon {
									position: absolute;
									top: -5px;
									right: -5px;
									width: 30px;
									height: 30px;
									font-size: 20px;
									color: #d5d5d5;
									cursor: pointer;
								}

								.Sqixian {
									font-weight: 100;
									padding-left: 15px;
									font-size: 18px;
									color: red;
									display: flex;
									align-items: center;

									.Sastar {
										padding-top: 7px;
									}

									.sl {
										font-size: 12px;
										color: #606266
									}
								}

								.input-control {
									width: 30vw;
									height: 40px;
									padding: 0 25 0 5px;
									padding-right: 40px;
									padding-left: 10px;
									border: 1px solid #dcdfe6;
									border-radius: 4px;
									font-size: 14px;
									color: #606266;
									transition: border-color 0.2s;
									box-sizing: border-box;
									background: #fff;
									position: relative;
									z-index: 2;


									&:focus {
										border-color: #409eff;
										outline: none;
									}
								}

								.clear-icon {
									font-size: 20px;
									width: 25px;
									height: 40px;
									position: absolute;
									top: 50%;
									left: 29vw;
									transform: translate(-50%, -50%);
									z-index: 30;
									cursor: pointer;
									color: #d5d5d5;

								}
							}

							.xm-content1 {
								font-size: 12px;
								color: red;
							}


						}
					}

				}
			}
		}
	}

	.msg {
		width: 100vw;
		height: 10vh;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 20px;
		background-color: #fdfdfd;
		height: 15vh;
		box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.6);

		.msg-main {
			/* display: flex; */
			position: relative;

			.msg-menu {
				display: flex;
				// flex-direction: column;
				align-items: center;
				justify-content: space-between;
				margin: 0 40px;
				color: #18688d;
				font-size: 15px;
				// font-weight: 700;
				// width: 30vw;

				.msg-img {
					width: 110px;
					height: 80px;
					// border-radius: 50%;
					// border: 1px solid #454962;
					// background-color: #e5e5e5;
					// box-shadow: 0 5px 16px rgba(0, 0, 0, 0.6);
					margin-bottom: 10px;

					filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3));
				}

				.msg-img1 {
					width: 160px;
					height: 120px;

					// border-radius: 50%;
					// border: 1px solid #454962;
					// background-color: #e5e5e5;
					filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0));
					margin-bottom: 10px;

				}
			}

			.mingxi {
				position: absolute;
				top: 100%;
				left: 0;
				right: 0;
				margin: 0 auto;
				/* 关键：横向居中 */
				/* bottom: 0; */
				z-index: 100;
				font-size: 13px;
				line-height: 25px;
				border: 1px solid #d5d5d5;
				border-radius: 5px;
				display: flex;
				flex-direction: column;
				align-items: start;
				padding: 10px;
				background-color: #e5e5e5;
				box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
				cursor: pointer;

				/* font-size: 12px; */
			}
		}
	}

	@keyframes bounce {

		0%,
		100% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-10px);

		}
	}

	.msg .msg-menu {
		transition: transform 0.3s ease;
	}

	.msg .msg-menu:hover {
		animation: bounce 0.5s ease;
		cursor: pointer;

	}

	.mingxi-content1 {
		padding-left: 6px;
		background-color: rgba(64, 158, 255, 0.3) !important;
		color: #333 !important;
		// font-weight: bold;
	}

	.a {
		width: 100vw;
		height: 60vh;
		position: absolute;
		top: 0;
		left: 0;
		background-color: aliceblue;
		z-index: 999;

	}

	.zlqd-jiage1 {
		position: absolute;
		top: 50%;
		right: -50px;
		transform: translate(-50%);
		font-size: 16px !important;
		// width: 420px;
		display: flex;
		align-items: center;
		justify-content: end;
		font-size: 13px;

		// display: flex;
		// justify-content: center;
		// align-items: center;

	}

	.gcscp {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 50px;
		cursor: pointer;
	}

	.cpimg {
		width: 20px;
		height: 20px;
		filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.3));
	}

	.cpimg:hover {
		filter: none;
		padding-top: 5px;
	}

	.paid-text {
		color: #f56c6c;
		font-weight: bold;
		margin-left: 10px;
	}

	.pay {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		// background-color: rgba(0, 0, 0, 0.2);
		z-index: 9999;

	}

	.fufei {
		margin-left: 20px;
	}

	.free-code-btn {
		margin-left: 10px;
	}

	.free-code-dialog-tip {
		margin-top: 10px;
		color: #909399;
		font-size: 12px;
	}

	.bzqxs {
		font-size: 10px;
	}

	.gcscat {
		display: flex;
		justify-content: left;
		align-items: center;
		gap: 15px;
	}
</style>
